"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./BoundingBox"), exports);
tslib_1.__exportStar(require("./Box"), exports);
tslib_1.__exportStar(require("./Dimensions"), exports);
tslib_1.__exportStar(require("./FaceDetection"), exports);
tslib_1.__exportStar(require("./FaceLandmarks"), exports);
tslib_1.__exportStar(require("./FaceLandmarks5"), exports);
tslib_1.__exportStar(require("./FaceLandmarks68"), exports);
tslib_1.__exportStar(require("./FaceMatch"), exports);
tslib_1.__exportStar(require("./LabeledBox"), exports);
tslib_1.__exportStar(require("./LabeledFaceDescriptors"), exports);
tslib_1.__exportStar(require("./ObjectDetection"), exports);
tslib_1.__exportStar(require("./Point"), exports);
tslib_1.__exportStar(require("./PredictedBox"), exports);
tslib_1.__exportStar(require("./Rect"), exports);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/classes/index.js
 ** module id = 49
 ** module chunks = 0
 **/